import { DropdownOption } from 'components/Input/Dropdown'
import { DomainType } from 'features/domains/types'

export const mapDomainToDropdownOption = (
  domain: DomainType | undefined
): DropdownOption => {
  return domain
    ? { label: domain.name, value: domain.id }
    : { label: '', value: '' }
}

export const mapDomainsToDropdownOptions = (
  domains: DomainType[]
): DropdownOption[] => domains.map(mapDomainToDropdownOption)

export const getDomainNamesFromParent = (domain: DomainType): string[] => {
  let namesArr: string[] = []
  let iterationDomain: DomainType | undefined = domain
  while (iterationDomain.parent) {
    namesArr.push(iterationDomain.name)
    iterationDomain = iterationDomain.parent
  }
  return namesArr.reverse()
}
